import {Data, EGDPerson, Room, EGDAddress, Doc, EGDFlsMan, EGDDocs} from '../../../types';

import {
    isArray,
    isString,
    isNotEmpty,
    mayBe,
    yesNo,
    isPresent,
    DATA_NOT_AVAILABLE,
} from './common';

export const regPeoples = (people: EGDPerson[]) => {
    const peopleByReg = isArray(people)
            ? people.filter(person => {
                return (person.regType === '1')
            })
            : [];

    return peopleByReg;
};

export const prebPeoples = (people: EGDPerson[]) => {
    const peoplesByPreb: EGDPerson[] = isArray(people)
            ? people.filter(person => person.regType === '2' || person.regType === '3')
            : [];

    return peoplesByPreb;
};

export const getZayavOwnNoreg = (data: Data) =>
        data && isString(data.zayavOwnNoreg) ? yesNo(data.zayavOwnNoreg !== '1') : DATA_NOT_AVAILABLE;

export const getOwnRooms = (rooms: Room[], id: string) => {
    const ownRooms = rooms.filter(r => r.flsid.toString() === id);
    const preparedOwnRooms = ownRooms.map(
            r =>
                    `${mayBe(r.nom)} комната общ.(заним.): ${mayBe(r.sRoomAll, ' кв.м.')} (${mayBe(
                            r.sRoom,
                            ' кв.м.'
                    )}) (${mayBe(r.roomPlan)})`
    );

    return isNotEmpty(preparedOwnRooms) ? preparedOwnRooms.join(';\n') : DATA_NOT_AVAILABLE;
};

export const getIsCommonFlats = (data: Data) =>
        data && isString(data.flatType) && data.flatType === 'Коммунальная';

export const getCommonRooms = (rooms: Room[], id: string) =>
        isArray(rooms) ? rooms.filter(r => r.flsid !== id) : [];

export const getCmanReg = (egdFlsMan: EGDFlsMan, id: string) => {
    const flsMan = isArray(egdFlsMan) && egdFlsMan.find(f => f.flsId === id);
    return flsMan ? flsMan.cmanReg : DATA_NOT_AVAILABLE;
};

export const getDocsData = (docs: EGDDocs): string[] => {
    const docToString = (doc: Doc): string => {
        const who = doc.who ? `выдан ${doc.who}` : '';
        const egrp_num = doc.egrpNum ? `, запись в ЕГРН №${doc.egrpNum}` : '';
        const egrp_date = doc.egrpDate ? `от ${doc.egrpDate}` : '';
        return [doc.name, who, egrp_num, egrp_date].join(' ');
    }

    return docs.doc.map(docToString);
};

export const getFeatures = (data: Data) => {
    const isCommonFlats = getIsCommonFlats(data);

    return `${mayBe(data.flatType)}, ${mayBe(data.croomFlat)}-комнатная ${
            isCommonFlats ? `(${data.roomCount} комн.)` : ''
    }`;
};

export const getAddress = ({houseType, street, house, korp, stroen, flat}: EGDAddress) => {
    return [
        isPresent(street) ? `ул. ${street}` : null,
        isPresent(house) ? `дом №${house}` : null,
        isPresent(korp) ? `корп. ${korp}` : null,
        isPresent(stroen) ? `строение ${stroen}` : null,
        isPresent(flat) ? (houseType === '6' ? `помещение №${flat}, общежити` : `кв. ${flat}`) : null,
    ]
            .filter(part => !!part)
            .join(' ');
};

export const getPrevAddress = ({
                                   houseType,
                                   prevStreet,
                                   prevHouse,
                                   prevKorp,
                                   prevStroen,
                                   prevFlat,
                               }: Data) => {
    const prevAddress = getAddress({
        houseType: houseType,
        street: prevStreet,
        house: prevHouse,
        korp: prevKorp,
        stroen: prevStroen,
        flat: prevFlat,
    });

    return isPresent(prevAddress) ? prevAddress : null;
};
